import { VIEW_TO_PATH } from '../../routes';
import { sendNotificationEmail } from '../../services/notifyEmail';
import { workingDaysInPeriod } from '../../utils/dates';
import { fmtDate } from '../../utils/format';

export default function absencesNotificationsHandlers(deps, api) {
  const { profile, appState } = deps;

  // ── Notifications email (relai SMTP Mailjet, voir notify-email et la doc Confluence "Intégrer
  // Mailjet en SMTP dans un projet") ──
  // Un échec d'envoi ne doit jamais faire échouer l'action métier elle-même (la demande/décision
  // est déjà enregistrée) : simplement loggué, jamais remonté à l'utilisateur comme une erreur bloquante.
  async function sendNotifyEmail({ to, subject, text }) {
    try {
      const { data, error } = await sendNotificationEmail(subject, text, to);
      if (error || data?.error) console.error('Erreur envoi email :', error || data?.error);
    } catch (e) {
      console.error('Erreur envoi email :', e);
    }
  }

  async function notifyAbsenceRequested(absence) {
    const requester =
      appState.devs.find((d) => d.id === absence.dev_id)?.nom || profile?.nom || 'Un utilisateur';
    const approverLink = `${window.location.origin}${VIEW_TO_PATH.devs}`;
    const dayCount = workingDaysInPeriod(absence.debut, absence.fin);
    await sendNotifyEmail({
      to: 'conges_validators',
      subject: `Nouvelle demande de congés - ${requester}`,
      text: `Bonjour,\n\n${requester} a soumis une demande de congés.\n\nDates : du ${fmtDate(absence.debut)} au ${fmtDate(absence.fin)}\nNombre de jours ouvrés demandés : ${dayCount} jour(s)\n\nLa demande est accessible via le lien suivant :\n${approverLink}\n\nBonne journée`,
    });
  }

  async function notifyAbsenceModified(absence) {
    const requester =
      appState.devs.find((d) => d.id === absence.dev_id)?.nom || profile?.nom || 'Un utilisateur';
    const approverLink = `${window.location.origin}${VIEW_TO_PATH.devs}`;
    const dayCount = workingDaysInPeriod(absence.debut, absence.fin);
    await sendNotifyEmail({
      to: 'conges_validators',
      subject: `Demande de congés modifiée - ${requester}`,
      text: `Bonjour,\n\n${requester} a modifié une demande de congés déjà acceptée — elle repasse en attente de validation.\n\nDates : du ${fmtDate(absence.debut)} au ${fmtDate(absence.fin)}\nNombre de jours ouvrés demandés : ${dayCount} jour(s)\n\nLa demande est accessible via le lien suivant :\n${approverLink}\n\nBonne journée`,
    });
  }

  async function notifyAbsenceCancelled(absence) {
    const requester =
      appState.devs.find((d) => d.id === absence.dev_id)?.nom || profile?.nom || 'Un utilisateur';
    const dayCount = workingDaysInPeriod(absence.debut, absence.fin);
    await sendNotifyEmail({
      to: 'conges_validators',
      subject: `Demande de congés annulée - ${requester}`,
      text: `Bonjour,\n\n${requester} a annulé une demande de congés.\n\nDates : du ${fmtDate(absence.debut)} au ${fmtDate(absence.fin)}\nNombre de jours ouvrés : ${dayCount} jour(s)\n\nBonne journée`,
    });
  }

  async function notifyAbsenceDecided(absence, accepted) {
    // Le demandeur n'est identifiable par email que depuis une session manager (st.devs porte
    // l'email uniquement côté managerView, voir loadAppData) — decideAbsence n'est de toute façon
    // appelable que depuis Équipe, page manager-only.
    const dev = appState.devs.find((d) => d.id === absence.dev_id);
    if (!dev?.email) return;
    const prenom = (dev.nom || '').split(' ')[0] || '';
    const dayCount = workingDaysInPeriod(absence.debut, absence.fin);
    const text = accepted
      ? `Bonjour ${prenom},\n\nVotre demande de congés a été validée.\n\nDates : du ${fmtDate(absence.debut)} au ${fmtDate(absence.fin)}\nNombre de jours ouvrés : ${dayCount} jour(s)\n\nBonnes vacances,`
      : `Bonjour ${prenom},\n\nVotre demande de congés concernant la période du ${fmtDate(absence.debut)} au ${fmtDate(absence.fin)} (${dayCount} jour(s) ouvrés) n'a pas pu être validée.\n\nPour plus d'informations, il faut contacter Guillaume ou Sandra.\n\nBonne journée`;
    await sendNotifyEmail({
      to: dev.email,
      subject: accepted
        ? 'Votre demande de congés a été acceptée'
        : "Votre demande de congés n'a pas été acceptée",
      text,
    });
  }

  return {
    sendNotifyEmail,
    notifyAbsenceRequested,
    notifyAbsenceModified,
    notifyAbsenceCancelled,
    notifyAbsenceDecided,
  };
}
